import { Box, VStack, Text } from "@chakra-ui/react";
import { EventProps, Event as RBCEvent, View } from "react-big-calendar";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { useTrans } from "../hooks";
import { AppTooltip } from "./AppTooltip";
import { UTIL } from "../config";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export type CalendarDataType = RBCEvent & {
    id: number;
    internshipId: number;
    internshipScheduleId: number;
    companyName: string;
    internshipName: string;
    internshipScheduleName: string;
    breakDuration: string;
    totalTime: string;
    startTime: string;
    endTime: string;
    color: string;
};

interface AppCalendarCustomEventProps extends EventProps<CalendarDataType> {
    view?: View;
    renderActions?: (event: CalendarDataType) => JSX.Element;
}

export const AppCalendarCustomEvent = ({
    event,
    view = "week",
    renderActions,
}: AppCalendarCustomEventProps) => {
    const { t } = useTrans();
    const color = event.color || "#f2f2f2";
    return (
        <Box
            w={"full"}
            h={"full"}
            bg={color}
            border="1px solid"
            borderColor={"var(--chakra-colors-greyT80)"}
            color={UTIL.getInvertHexColor(color)}
        >
            <AppTooltip
                label={`${event?.companyName} | ${event.internshipName} (${event.internshipScheduleName})`}
            >
                <VStack alignItems={"start"}>
                    {renderActions && renderActions(event)}
                    {view !== "month" && (
                        <VStack alignItems={"start"} gap={2} p={1}>
                            <Text as={"span"} textStyle={"boldXs"}>
                                {event?.companyName}
                            </Text>
                            <Text
                                as={"span"}
                                textStyle={"mediumXs"}
                                // textDecoration={"underline"}
                            >
                                {`${event.internshipName} (${event.internshipScheduleName})`}
                            </Text>
                            <Text as={"span"} textStyle={"mediumXs"}>
                                {t(
                                    "ent.InternshipSchedule:breakDuration.label"
                                )}
                                : {event?.breakDuration}
                            </Text>
                            <Text as={"span"} textStyle={"mediumXs"}>
                                {t("ent.InternshipSchedule:totalTime.label")}:{" "}
                                {event?.totalTime}
                            </Text>
                        </VStack>
                    )}
                </VStack>
            </AppTooltip>
        </Box>
    );
};
